import { render, staticRenderFns } from "./DrawingPictureArtqr.vue?vue&type=template&id=5018a015&scoped=true"
import script from "./DrawingPictureArtqr.vue?vue&type=script&setup=true&lang=js"
export * from "./DrawingPictureArtqr.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DrawingPictureArtqr.vue?vue&type=style&index=0&id=5018a015&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5018a015",
  null
  
)

export default component.exports